export const GET_MESH_DATA = "GET_MESH_DATA";
export const SET_MESH_DATA = "SET_MESH_DATA";
